export const MAX_ITEMS_TO_COMPARE = 4;
